import React, { Component } from "react";
import Table from "../../common/components/Table";
import TableHeader from "../../common/components/TableHeader";
import { Localize } from "../../../locale/localization";

class BestRegionsBlock extends Component {
  tableHead = [
    { name: "place", uiName: "" },
    { name: "name", uiName: Localize("name") },
    { name: "sales", uiName: Localize("region.top.score") },
    { name: "people", uiName: Localize("region.top.people") }
  ];

  renderTableHeader = () => {
    return <TableHeader items={this.tableHead} sortable={false} />;
  };

  renderScoreRow = item => {
    const { name, people, sales, position } = item;

    return (
      <tr key={name}>
        <td className="strong">{position}.</td>
        <td className="strong">{name}</td>
        <td>
          {sales} {Localize("score.short")}
        </td>
        <td>{people}</td>
      </tr>
    );
  };

  render() {
    const { scores } = this.props;

    return scores && scores.length > 0 ? (
      <Table
        renderHeader={this.renderTableHeader}
        items={scores
          .slice(0, 6)
          .map((entry, position) =>
            Object.assign({}, entry, { position: position + 1 })
          )}
        renderItem={this.renderScoreRow}
        renderFooter={this.renderTableFooter}
        widths={["5%", "45%", "25%", "25%"]}
      />
    ) : (
      <p>{Localize("region.top.empty")}.</p>
    );
  }
}

export default BestRegionsBlock;



// WEBPACK FOOTER //
// ./src/modules/region/components/BestRegionsBlock.js